import { Flame, Snowflake, Droplet } from "lucide-react";

const FACES = [
  { t: "rotateY(0deg)", g: "from-[#f7893a] to-[#e5401a]", I: Flame },
  { t: "rotateY(90deg)", g: "from-[#5fd0fa] to-[#2b9be8]", I: Snowflake },
  { t: "rotateY(180deg)", g: "from-[#f7893a] to-[#e5401a]", I: Flame },
  { t: "rotateY(-90deg)", g: "from-[#5fd0fa] to-[#2b9be8]", I: Snowflake },
  { t: "rotateX(90deg)", g: "from-[#5b8cf5] to-[#2f5be6]", I: Droplet },
  { t: "rotateX(-90deg)", g: "from-[#2f5be6] to-[#1d3aa8]", I: Droplet },
];

export const Cube3D = ({ size = 150 }) => {
  const half = size / 2;
  return (
    <div style={{ width: size, height: size, perspective: 900 }} data-testid="hero-cube">
      <div className="relative w-full h-full cube-spin" style={{ transformStyle: "preserve-3d" }}>
        {FACES.map(({ t, g, I }, i) => (
          <div key={i}
            className={`absolute inset-0 bg-gradient-to-br ${g} grid place-items-center border border-white/25`}
            style={{ transform: `${t} translateZ(${half}px)`, backfaceVisibility: "hidden" }}>
            <I className="text-white drop-shadow" style={{ width: size * 0.32, height: size * 0.32 }} strokeWidth={2.2} fill={i === 1 || i === 3 ? "none" : "white"} />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/0 via-white/10 to-white/0" />
          </div>
        ))}
      </div>
    </div>
  );
};
